let base = window._env_.VUE_APP_ADMIN_HOST
let finBase = window._env_.VUE_APP_FIN_CENTER_HOST


export const queryWaitProcessJobsApi = params => {
  return axios.post(`${base}/batch_jobs/all_batch_jobs`, params)
}

export const queryFinanceExportJobsApi = params => {
  return axios.post(`${finBase}/batch_jobs/query`, params)
}

export const exportCollectionListApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_collection_list`, params)
}

export const exportCollectionDetailApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_collection_detail`, params)
}

export const exportReceiptListApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_receipt_list`, params)
}
export const exportPreReceiptListApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_pre_receipt_list`, params)
}

export const exportReceiptCollectionApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_receipt_collection`, params)
}
export const exportUnReceiptCollectionApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_receipt_uncollection`, params)
}
export const exportFinancePaymentListApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_payment_list`, params)
}
export const exportFinancePaymentDetailApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_payment_detail`, params)
}
export const exportFinanceWriteOffDetailApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_payment_writeoff_detail`, params)
}
export const exportFinanceWriteOffStatusApi = params => {
  return axios.post(`${finBase}/batch_jobs/finance/export_payment_writeoff_status`, params)
}

export const approveBatchJob = params => {
  return axios.post(`${base}/batch_jobs/approve_batch_job`, params)
}



// WEBPACK FOOTER //
// ./src/views/batch-jobs/batch-jobs.api.js